import React from 'react';
import './css/ContactUs.css';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaEnvelope, FaPhone, FaGlobe, FaHandshake } from 'react-icons/fa';
import businessVerticalsBanner from '../assets/images/Busines Vertcial- 21 June -A  (1).png';
import SEO from '../components/SEO';
import { localBusinessSchema } from '../components/StructuredData';

const ContactUs = () => {
  return (
    <>
      <SEO
        title="Contact Nimble Group - Get Expert Chemical Solutions Consultation"
        description="Connect with Nimble Group's technical experts for customized eco-friendly chemical solutions. Get consultation on aromatic chemicals, heat dissipation, and sustainable industrial solutions."
        keywords="contact nimble group, chemical consultation, technical experts, eco-friendly solutions, chemical manufacturing contact, sustainable chemistry consultation, Nimble Technologies Contact,  Nimble Mumbai, Nimble Technologies pvt Ltd, Nimble Mumbai office, Nimble Eco Solutions, Nimble chemical manufacturers, Nimble gogreen, Nimble Sustainable Solutions, Nimble EHS Solutions"
        canonical="/contact"
        structuredData={localBusinessSchema}
      />
      <ContactUsContent />
    </>
  );
};

const ContactUsContent = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const bannerVariants = {
    hidden: { opacity: 0, y: -30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 15,
        delay: 0.2
      }
    }
  };

  const headerVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 15
      }
    }
  };

  const sectionVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 15
      }
    }
  };

  const iconVariants = {
    hidden: { scale: 0 },
    visible: {
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 200,
        damping: 20
      }
    }
  };

  return (
    <motion.div
      className="contact-container"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.div
        className="banner-container"
        variants={bannerVariants}
      >
        <motion.img
          src={businessVerticalsBanner}
          alt="Nimble Business Verticals - Aromatic Chemicals, Eco-Friendly Cleaners, Heat Dissipation Compounds, and Green Metal Working Additives"
          className="business-verticals-banner"
        />
        <div className="banner-overlay">
          <h1 className="banner-title">Our Business Verticals</h1>
          <p className="banner-subtitle">
            Discover our comprehensive range of sustainable solutions across multiple industries - 
            from Aromatic Chemicals to Green Metal Working Additives
          </p>
        </div>
      </motion.div>
      
      <motion.div 
        className="contact-header"
        variants={headerVariants}
      >
        <h1>Let's Connect</h1>
        <div className="header-content">
          <motion.div
            variants={iconVariants}
            whileHover={{ rotate: 15, scale: 1.1 }}
          >
            <FaHandshake className="header-icon" />
          </motion.div>
          <motion.h2
            variants={headerVariants}
          >
            Partner With Us for a Greener, Safer Tomorrow
          </motion.h2>
          <motion.p
            variants={headerVariants}
          >
            At Nimble Go Green, we believe real progress happens through meaningful conversations.
            Whether you have a technical challenge, seek eco-friendly alternatives, or wish to
            collaborate on responsible industrial practices — we're always here to engage.
          </motion.p>
        </div>
      </motion.div>

      <div className="contact-sections">
        <motion.div
          className="contact-section"
          variants={sectionVariants}
          whileHover={{ scale: 1.02 }}
        >
          <h3>📞 Reach Out to Our Experts</h3>
          <div className="contact-info">
            <motion.div className="info-item" variants={sectionVariants}>
              <FaMapMarkerAlt className="icon" />
              <p>Plot C39,A-24, TTC Industrial Area, MIDC Pawne, Thane Belapur Road Navi Mumbai</p>
            </motion.div>
            <motion.div className="info-item" variants={sectionVariants}>
              <FaEnvelope className="icon" />
              <p>
                <a href="mailto:care@nimblegogreen.com">care@nimblegogreen.com</a>
              </p>
            </motion.div>
            <motion.div className="info-item" variants={sectionVariants}>
              <FaPhone className="icon" />
              <p>
                <a href="tel:7249447788">7249447788</a>
              </p>
            </motion.div>
            <motion.div className="info-item" variants={sectionVariants}>
              <FaGlobe className="icon" />
              <p>
                <a href="https://www.nimblegogreen.com" target="_blank" rel="noopener noreferrer">
                  www.nimblegogreen.com
                </a>
              </p>
            </motion.div>
          </div>
        </motion.div>

        <motion.div
          className="contact-section"
          variants={sectionVariants}
          whileHover={{ scale: 1.02 }}
        >
          <h3>📑 For Business Enquiries</h3>
          <p>
            To explore customized sustainable solutions for your industrial applications or learn
            more about our eco-friendly product ranges:
          </p>
          <div className="contact-info">
            <motion.div className="info-item" variants={sectionVariants}>
              <FaEnvelope className="icon" />
              <p>
                <a href="mailto:mts@nimblegogreen.com">mts@nimblegogreen.com</a>
              </p>
            </motion.div>
            <motion.div className="info-item" variants={sectionVariants}>
              <FaPhone className="icon" />
              <p>
                <a href="tel:7249447788">7249447788</a>
              </p>
            </motion.div>
          </div>
          <motion.p
            className="response-time"
            variants={sectionVariants}
          >
            We respond to all business enquiries within 24 working hours.
          </motion.p>
        </motion.div>

        <motion.div
          className="contact-section"
          variants={sectionVariants}
          whileHover={{ scale: 1.02 }}
        >
          <h3>📣 Say Hello</h3>
          <motion.p variants={sectionVariants}>
            Even if it's just to exchange ideas on sustainability, green chemistry, or industrial
            EHS trends — we'd love to hear from you.
          </motion.p>
          <motion.p
            className="mission-statement"
            variants={sectionVariants}
          >
            Let's co-create a future where industries grow without harming the world that hosts them.
          </motion.p>
          <motion.p
            className="discover-text"
            variants={sectionVariants}
          >
            Discover how we're building a cleaner, greener industrial world — one responsible
            solution at a time.
          </motion.p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ContactUs; 